import { useEffect } from 'react';
import { checkAndRegisterDevice } from 'App/capacitor/device';
import useVerifyNotificationToken from 'App/settings/verifyNotificationToken';

function useNotifications() {
  useVerifyNotificationToken();

  useEffect(() => {
    checkAndRegisterDevice();
  }, []);
}

export default useNotifications;
